import Backbone from 'backbone';

const $ = Backbone.$;

export default {
  run(editor, sender) {
    var command = sender.id;
    editor.editor.set('device', command);
  },

  stop() {}
};
